require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M25 6.25C14.645 6.25 6.25 14.645 6.25 25c0 8.285 5.371 15.313 12.824 17.793.938.172 1.278-.406 1.278-.902 0-.446-.016-1.625-.024-3.192-5.215 1.133-6.316-2.511-6.316-2.511-.852-2.168-2.082-2.743-2.082-2.743-1.703-1.164.129-1.14.129-1.14 1.882.133 2.87 1.933 2.87 1.933 1.673 2.864 4.391 2.035 5.458 1.559.172-1.211.656-2.04 1.191-2.508-4.164-.473-8.539-2.082-8.539-9.266 0-2.046.73-3.722 1.93-5.03-.196-.477-.836-2.384.183-4.966 0 0 1.575-.504 5.157 1.922A18.046 18.046 0 0 1 25 15.32c1.594.008 3.2.215 4.695.63 3.578-2.427 5.153-1.923 5.153-1.923 1.023 2.582.379 4.489.183 4.965 1.203 1.309 1.93 2.985 1.93 5.031 0 7.204-4.387 8.786-8.563 9.25.672.579 1.274 1.723 1.274 3.473 0 2.504-.024 4.527-.024 5.145 0 .5.336 1.082 1.29.898C38.383 40.305 43.75 33.281 43.75 25c0-10.355-8.395-18.75-18.75-18.75zm0 0"
  }));
};

exports["default"] = _default;